<template>
  <div id="QuestionFormInformation">
    <div class="maxContainer">
      <v-form ref="form" v-model="valid">
        <transition-group name="fade" tag="div">
          <div key="step1" v-if="showStep >= 1" ref="stepArea1">
            <QuestionCover>
              <QuestionTitle title="Personal Information"></QuestionTitle>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="firstname"
                      label="First name"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="lastname"
                      label="Last name"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="phonenumber"
                      label="Phone number"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="email"
                      label="E-mail"
                      :rules="emailRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p>Do you have a myPAbox subscription?</p>
                    <v-radio-group
                      v-model="mypaboxsubs"
                      row
                      :mandatory="true"
                      :rules="requireRule"
                    >
                      <v-radio label="Yes" value="no"></v-radio>
                      <v-radio label="No" value="yes"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </QuestionCover>
          </div>
          <div key="step2" v-if="showStep >= 2" ref="stepArea2">
            <QuestionCover>
              <QuestionTitle title="Academic History"></QuestionTitle>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="scienceGpaValue"
                      label="What is your science GPA?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="undergraduatedegree"
                      label="What is your undergraduate degree?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="undergraduateGpa"
                      label="What is your undergraduate GPA?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="nonsciencegap"
                      label="What is your non-science GPA?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </QuestionCover>
          </div>
          <div key="step3" v-if="showStep >= 3" ref="stepArea3">
            <QuestionCover>
              <QuestionTitle title="Experiences"></QuestionTitle>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="pcehce"
                      label="What type and how many hours of PCE/HCE do you have?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="shadowinghours"
                      label="How many shadowing hours do you have?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="volunteerhours"
                      label="How many volunteer hours do you have?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="admissionstesting"
                      label="Have you taken any admissions testing (GRE, CASPer, PA-CAT)? If so, what were the results?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </QuestionCover>
          </div>
          <div key="step4" v-if="showStep >= 4" ref="stepArea4">
            <QuestionCover>
              <QuestionTitle title="Applicant Status"></QuestionTitle>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="CASPA"
                      label="Which CASPA cycle are preparing to apply for?"
                      :rules="requireRule"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <p>
                      Have you applied to PA school in a previous CASPA cycle?
                    </p>
                    <v-radio-group
                      v-model="applicanttimes"
                      row
                      :mandatory="true"
                      :rules="requireRule"
                    >
                      <v-radio
                        label="No - 1st time applicant"
                        value="1"
                      ></v-radio>
                      <v-radio
                        label="Yes - 2nd time applicant"
                        value="2"
                      ></v-radio>
                      <v-radio
                        label="Yes - 3rd time applicant"
                        value="3"
                      ></v-radio>
                      <v-radio
                        label="Yes - > 3rd time applicant"
                        value="3+"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p>Have you ever interviewed with a PA program before?</p>
                    <v-radio-group
                      v-model="interviewed"
                      row
                      :mandatory="true"
                      :rules="requireRule"
                    >
                      <v-radio label="Yes" value="yes"></v-radio>
                      <v-radio label="No" value="no"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="6">
                    <p>
                      Do you have a PA school interview scheduled at this time?
                    </p>
                    <v-radio-group
                      v-model="interviewedBefore"
                      row
                      :mandatory="true"
                      :rules="requireRule"
                    >
                      <v-radio label="Yes" value="yes"></v-radio>
                      <v-radio label="No" value="no"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="12">
                    <p>Other comments/concerns, goals, or areas of weakness</p>
                    <v-textarea
                      solo
                      name="input-7-4"
                      label="Write Here"
                    ></v-textarea>
                  </v-col>
                  <v-col v-if="visibleUploader" cols="12" md="12">
                    <p>
                      Attachments: Personal statement (required for personal
                      statement edit and for mock interview).
                    </p>
                    <v-file-input
                      :rules="fileRules"
                      v-model="attachedFiles"
                      chips
                      multiple
                      label="Upload File"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </QuestionCover>
          </div>
        </transition-group>

        <v-btn
          v-if="showStep == 1"
          class="myPaBoxButton"
          color="info"
          depressed
          block
          large
          :disabled="!valid"
          @click="showNextStep()"
          >Next Step</v-btn
        >
        <v-btn
          v-if="showStep == 2"
          class="myPaBoxButton"
          color="info"
          depressed
          block
          large
          :disabled="!valid"
          @click="showNextStep()"
          >Next Step</v-btn
        >
        <v-btn
          v-if="showStep == 3"
          class="myPaBoxButton"
          color="info"
          depressed
          block
          large
          :disabled="!valid"
          @click="showNextStep()"
          >Next Step</v-btn
        >

        <v-btn
          v-if="showStep == 4"
          class="myPaBoxButton"
          color="info"
          depressed
          block
          large
          :disabled="!valid"
          @click="showNextStep()"
          >Proceed</v-btn
        >
      </v-form>
    </div>
  </div>
</template>

<script>
import QuestionTitle from "@/components/Services/ServicesQuestions/QuestionTitle";
import QuestionCover from "@/components/Services/ServicesQuestions/QuestionCover";
import ServiceItemMixin from "../service-item-mixins";
import { mapGetters } from "vuex";
import * as firebase from "firebase";

export default {
  name: "QuestionFormInformation",
  mixins: [ServiceItemMixin],
  props: ["visibleUploader"],
  data() {
    return {
      valid: false,
      firstname: "",
      lastname: "",
      phonenumber: "",
      email: "",
      mypaboxsubs: "no",
      scienceGpaValue: "",
      undergraduatedegree: "",
      undergraduateGpa: "",
      nonsciencegap: "",
      pcehce: "",
      shadowinghours: "",
      volunteerhours: "",
      admissionstesting: "",
      CASPA: "",
      applicanttimes: "",
      interviewed: "",
      interviewedBefore: "",
      showStep: 1,
      attachedFiles: [],
      requireRule: [(v) => !!v || "Required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      fileRules: [
        (v) => !!v || "File is required",
        (v) => (v && v.length > 0) || "File is required",
      ],
    };
  },
  components: {
    QuestionTitle,
    QuestionCover,
  },
  computed: {
    // TODO: Restore and Edit quiz
    ...mapGetters(["scienceGpa"]),
    //     overallCaspaGpa
    // nonscienceCaspaGpa
    // overallGpa
    // nonscienceGpa
  },
  methods: {
    async showNextStep() {
      this.showStep = this.showStep + 1;
      if (this.showStep > 4) {
        if (!this.$refs.form.validate()) return null;
        const downloadUrls = await this.uploadFileToFirebase();
        const quizRef = await this.saveQuiz({
          firstname: this.firstname,
          lastname: this.lastname,
          phonenumber: this.phonenumber,
          email: this.email,
          mypaboxsubs: this.mypaboxsubs,
          undergraduatedegree: this.undergraduatedegree,
          undergraduateGpa: this.undergraduateGpa,
          nonsciencegap: this.nonsciencegap,
          pcehce: this.pcehce,
          shadowinghours: this.shadowinghours,
          volunteerhours: this.volunteerhours,
          admissionstesting: this.admissionstesting,
          CASPA: this.CASPA,
          applicanttimes: this.applicanttimes,
          interviewed: this.interviewed,
          interviewedBefore: this.interviewedBefore,
          attachments: downloadUrls,
        });
        this.$emit("onSubmit", quizRef);
      }
    },
    async saveQuiz(payload) {
      const db = firebase.firestore();
      const quizes = db.collection("QuizResponses");
      const docRef = await quizes.add(payload);
      return docRef.id;
    },
    async uploadFileToFirebase() {
      if (!this.attachedFiles.length) return [];
      const storageRef = firebase.storage().ref();
      const uploadRefs = [];
      for (const file of this.attachedFiles) {
        const snapShot = await storageRef
          .child(`${this.user.uid}-${file.name}`)
          .put(file);
        const downloadUrl = await snapShot.ref.getDownloadURL();
        uploadRefs.push(downloadUrl);
      }
      return uploadRefs;
    },
  },
  created() {
    if (this.isLoggedIn) {
      this.email = this.user.email;
      if (this.validSubscription) {
        this.mypaboxsubs = true;
      }

      if (this.scienceGpa) {
        this.scienceGpaValue = this.scienceGpa;
      }
    }
  },
};
</script>

<style scoped>
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.myPaBoxButton {
  background-color: #191340 !important;
  border-color: #191340 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicesQuestions/QuestionFormInformation.vue